import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonForm } from "../common-form/common-form";
import { KeyPersonnelFormKey } from '../../../../../shared/utils/types';
import { KEY_PERSONNEL_DETAILS_FORM_KEYS } from '../../../../../shared/utils/constants';
import { Header } from '../../../../../core/services/header';

@Component({
  selector: 'app-individual-owners',
  imports: [CommonModule, CommonForm],
  templateUrl: './individual-owners.html',
  styleUrl: './individual-owners.css'
})
export class IndividualOwners {
  @Input() data: any;
  @Output() formSubmit = new EventEmitter<any>();
  @Output() closeCurrentForm = new EventEmitter<any>();

  activeForm: KeyPersonnelFormKey = KEY_PERSONNEL_DETAILS_FORM_KEYS.INDIVIDUAL_OWNERS;

  constructor(private headerService: Header) {

  }

  ngOnInit(): void {
    //Set header configs
    this.headerService.updateConfig({
      title: 'HEADER_TITLES.INDIVIDUAL_OWNERS',
      showNotifications: false,
      showRightSection: false,
      dropdownOptions: []
    });
  }

  ngOnDestroy(): void {
    this.headerService.resetConfig();
  }



  handleFormSubmission(formData: any) {
    // console.log("Received form data:", formData);
    this.formSubmit.emit(formData);
    //todo handle api calls
    this.closeCurrentForm.emit();
  }

}
